export function MediaItem (){
    return (
        <>
            <div>
                Ceci est la page des media
            </div>
        </>
    )
}